import { connect } from 'react-redux';
import SchedulerComponent from './SchedulerComponent';

import { userOperations } from '_data/modules/Users';
import { requestsOperations } from '../Requests/duck';
import { scheduleOperations } from './duck';

const mapStateToProps = ({
  locationReducer,
  appReducer,
  scheduleReducer,
}) => {
  return {
    locationId: locationReducer.location_code,
    actionJobs: appReducer.actionJobs.data,
    loading: scheduleReducer.schedules.loading,
    managers: appReducer.managers.users,
    associates: appReducer.associates.users,
    allUsers: appReducer.allUsers.users,
    removedUsers: appReducer.removedUsers.users,
    pendingUsers: appReducer.pendingUsers.users,
    plans: appReducer.plans.data,
    locationData: locationReducer.location_data,
  };
};

const mapDispatchToProps = (dispatch) => {

  const  getPendingUsers = (locationId) => {
    dispatch(userOperations.fetchPendingUsers(locationId));
  };

  const getLocationEmployeesNew = (locationId) => {
    const params = {
    locationId: locationId,
    page: 1,
  };
    dispatch(requestsOperations.fetchAllUsers(params));
  };

  const getLocationSchedules = (locationId) => {
      dispatch(scheduleOperations.fetchLocationSchedules(locationId));
  };

  const getLocationActionJobs = (locationId) => {
    dispatch(scheduleOperations.fetchLocationActionJobs(locationId));
  };
  

  return { 
    getPendingUsers,
    getLocationEmployeesNew,
    getLocationSchedules,
    getLocationActionJobs,
  };
};

const SchedulerContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SchedulerComponent);

export default SchedulerContainer;
